import React from 'react';
import { StyleSheet, View } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import Text from '@/components/Typography/Text';
import { CtaRow, GhostCta, PrimaryCta, Section, StoreBadges, useLanding } from './LandingKit';
import { fluid, isWeb } from './landingTokens';
import FooterPixelScene from './FooterPixelScene';

function LandingClosing() {
  const { isXS, isCompact, width } = useLanding();
  return (
    <View style={{ width: '100%', position: 'relative', overflow: 'hidden', backgroundColor: '#081423' }}>
      <View pointerEvents="none" aria-hidden={isWeb ? true : undefined} accessibilityElementsHidden importantForAccessibility="no-hide-descendants" style={StyleSheet.absoluteFillObject}>
        <View style={{ position: 'absolute', left: 0, right: 0, bottom: 0, height: isCompact ? 420 : '100%' }}>
          <FooterPixelScene />
        </View>
        <LinearGradient
          colors={isCompact ? ['#081423', 'rgba(8,20,35,.92)', 'rgba(8,20,35,0)'] : ['rgba(5,16,27,.72)', 'rgba(5,16,27,.35)', 'rgba(5,16,27,0)']}
          start={{ x: 0, y: 0 }}
          end={isCompact ? { x: 0, y: 1 } : { x: 1, y: 0 }}
          locations={isCompact ? [0, 0.5, 0.8] : [0, 0.5, 1]}
          style={StyleSheet.absoluteFillObject}
        />
      </View>
      <Section label="Get started with Gab AI" contentStyle={{ paddingTop: fluid(width, 56, 88), paddingBottom: isCompact ? 260 : 80 }}>
        <View style={{ maxWidth: 580, gap: 22 }}>
          <Text tag="h2" weight="semibold" style={{ color: '#FFFFFF', fontSize: fluid(width, 38, 56), lineHeight: Math.round(fluid(width, 44, 62)), letterSpacing: -1.7 }}>Make time for living.</Text>
          <Text style={{ color: '#E0E7EC', fontSize: 17, lineHeight: 27, maxWidth: 410 }}>Start with one task you’d love to hand off. Try Gab AI free, or get Gab AI Work Agent with Plus and put it to work.</Text>
          <View style={{ gap: 12 }}>
            <CtaRow><PrimaryCta tone="onDark" restrained label="Get started free" full={isXS} /><GhostCta tone="onDark" label="View plans" href="/pricing" /></CtaRow>
            <Text style={{ color: '#D2DDE5', fontSize: 12 }}>No credit card required to start.</Text>
          </View>
          <View style={{ marginTop: 12, paddingTop: 24, borderTopWidth: 1, borderTopColor: 'rgba(255,255,255,.2)', gap: 16 }}>
            <Text style={{ color: '#D2DDE5', fontSize: 13 }}>On your Mac. In your browser. On the go.</Text>
            <StoreBadges featuredMac showExtension scale={0.85} style={{ alignSelf: 'flex-start' }} />
          </View>
        </View>
      </Section>
    </View>
  );
}
export default React.memo(LandingClosing);
